import BusinessApp from "./app"
import initRouter from "./router"
import store from "@/store/"
import globals from "@/utils/globals"
import i18n from "@/modules/i18n"

export default (Vue, { id }) => {
  const el = document.querySelector(`#${id}`)

  if (!el) {
    return
  }

  const props = (globals[id] && globals[id].props) || {}
  const router = initRouter()

  return new Vue({
    name: "BusinessMount",
    el,
    router,
    store,
    i18n,
    render: (h) => h(BusinessApp, { props })
  })
}
